import { z } from 'zod';
import { CANALES_DE_AVISO, } from '../catalogos/eventos.js';
/**
 * Preferencias de aviso de una paciente (F4.1, plan maestro §9.3).
 *
 * Sin consentimiento registrado de un canal, por ese canal no sale nada. Hoy
 * lo registra el personal del consultorio, con su nombre; el portal (F4.3) lo
 * dejara registrar a la paciente. El horario de silencio es en la hora local
 * del consultorio: lo que cae dentro se envia al terminar.
 */
const hora = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Hora en formato HH:MM');
export const esquemaPreferenciasDeAvisos = z
    .object({
    canales: z
        .object(Object.fromEntries(CANALES_DE_AVISO.map((canal) => [canal, z.boolean()])))
        .strict(),
    silencio: z
        .object({ desde: hora, hasta: hora })
        .strict()
        .refine((s) => s.desde !== s.hasta, 'El silencio no puede empezar y terminar igual')
        .nullable(),
})
    .strict();
//# sourceMappingURL=avisos.js.map